import { EXPANDED_MEMBERS, EXPANDED_POSTS, EXPANDED_LEADERBOARD } from "../../mockData";

// Static fallback MEMBERS registry — real data flows through communityApi.fetchMembers()
export const MEMBERS = {
  ...EXPANDED_MEMBERS,
};

export const POSTS_DATA = EXPANDED_POSTS;
export const LEADERBOARD = EXPANDED_LEADERBOARD;

export const HINTS = ["Search drills, coaches, insights...","Try \"finishing under contact\"...","Search by coach name...","Find practice plans...","Try \"ball handling games\"..."];
